import { NEWS_THEME } from 'src/views/News/newsTheme';

/**
 * Shared onboarding page light/dark surface tokens.
 * Dark values match the existing onboarding chrome (null = MUI dark theme default);
 * light matches the news/events light theme.
 */

export const ONBOARDING_THEME = {
  dark: {
    pageBg: null,
    cardBg: '#282C34',
    cardText: 'white',
    cardBorder: 'none',
    cardShadow: undefined,
    logo: '/static/1000containers-logo-white.svg',
    /** null = mobile uses `logo` at its stacked mobile size. */
    mobileHorizontalLogo: null,
    optionBorder: null,
    optionText: null,
    buttonBorder: null,
    buttonText: null,
    buttonDisabledBorder: null,
    buttonDisabledText: null,
  },
  light: {
    pageBg: NEWS_THEME.light.pageBg,
    cardBg: '#ffffff',
    cardText: '#0F172A',
    cardBorder: '1px solid rgba(15, 23, 42, 0.06)',
    cardShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
    /** Dark-text variant of `/static/1000containers-logo-white.svg` for light backgrounds. */
    logo: '/static/1000containers-logo-dark.svg',
    /** Same asset as inventory mobile light header. */
    mobileHorizontalLogo: NEWS_THEME.light.horizontalLogo,
    optionBorder: '#CBD5E1',
    optionText: '#0F172A',
    buttonBorder: '#CBD5E1',
    buttonText: '#0F172A',
    buttonDisabledBorder: '#E5E7EB',
    buttonDisabledText: '#94A3B8',
  },
};

export function getOnboardingThemeTokens(lightTheme) {
  return lightTheme ? ONBOARDING_THEME.light : ONBOARDING_THEME.dark;
}
